import React, { useEffect, useState } from "react";
import PaymentsList from "./RecordTable";
import paymentApi from "../../api/paymentApi";
import { toast } from "react-toastify";

export default function PaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPayments = async () => {
    setLoading(true);
    try {
      const response = await paymentApi.getAllPayments({ page: 0, limit: 100 });
      const data = response?.data?.data;
      const records = data?.payments || data?.content || data?.items || data || [];
      setPayments(Array.isArray(records) ? records : []);
    } catch (error) {
      console.error("Failed to load payments:", error);
      toast.error("Unable to load payments.");
      setPayments([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPayments();
  }, []);

  const updatePayment = async (updatedPayment) => {
    try {
      await paymentApi.updatePayment(updatedPayment.id, updatedPayment);
      toast.success("Payment updated successfully.");
      loadPayments();
    } catch (error) {
      console.error("Failed to update payment:", error);
      toast.error("Failed to update payment.");
    }
  };

  const deletePayment = async (id) => {
    try {
      await paymentApi.deletePayment(id);
      toast.success("Payment deleted successfully.");
      loadPayments();
    } catch (error) {
      console.error("Failed to delete payment:", error);
      toast.error("Failed to delete payment.");
    }
  };

  return (
    <PaymentsList
      payments={payments}
      loading={loading}
      onUpdatePayment={updatePayment}
      onDeletePayment={deletePayment}
    />
  );
}
